export default "__VITE_ASSET__DfoMXTn1__"